import { ImageProps } from 'next/image';
import { ThemeLogoType } from 'components/themeLogo';
import dynamic from 'next/dynamic';

export type UploadDocumentModalContent = {
  title: string;
  description: string;
  image: ImageProps;
};
export type UploadDocumentModalProps = {
  isOpenModal: boolean;
  content: UploadDocumentModalContent;
  logoBrand?: ThemeLogoType;
  closeModal: () => void;
};

export const UploadDocumentModal = dynamic<UploadDocumentModalProps>(
  () => import('components/modals/uploadDocumentModal/UploadDocumentModal').then((mod) => mod.UploadDocumentModal),
  { ssr: false }
);
